<template>
  <validation-provider v-slot="{ errors }"
                       :name="name"
                       :rules="validate"
                       tag="div"
                       class="checkbox">
    <div class="checkbox-body">
      <v-checkbox v-model="intervalVal"
                  :ripple="false"
                  :hide-details="hideDetails"
                  :error-messages="errors"
                  @change="emitInput">

        <template v-slot:label>
          <div class="checkbox-label"
               :class="{ 'checkbox-label_has-errors': !!errors.length }">
            <p class="checkbox-label-text">{{ label }}</p>
            <p class="checkbox-label-lead">{{ text }}</p>
          </div>
        </template>
      </v-checkbox>
    </div>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import isNull from "lodash/isNull";

export default {
  components: {
    ValidationProvider,
  },

  props: {
    label: {
      type: String,
    },
    value: {
      type: Boolean,
    },
    text: {
      type: String,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    name: {
      Type: String,
    },
    validate: {
      type: String,
    },
  },

  watch: {
    value(newVal) {
      if (newVal !== this.intervalVal) {
        this.intervalVal = newVal;
      }
    },
  },

  data() {
    return {
      intervalVal: this.value,
    };
  },

  methods: {
    emitInput(newVal) {
      const isNullValue = isNull(newVal);

      this.$emit("input", isNullValue ? false : newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  margin-bottom: 10px;

  .checkbox-body {
    display: flex;
    align-items: center;
  }

  ::v-deep .v-input__slot {
    align-items: flex-start;
    margin-bottom: 3px;
  }

  &[bold] {
    ::v-deep .v-input {
      .checkbox-label-text {
        font-weight: 600;
      }
    }
  }

  .checkbox-label {
    display: flex;
    flex-direction: column;

    .checkbox-label-text {
      margin-bottom: 5px;
      font-size: 16px;
    }

    .checkbox-label-lead {
      margin-bottom: 0;
      font-size: 12px;
    }
  }

  &[center] {
    ::v-deep .v-input {
      justify-content: center;
    }
  }
}
</style>










